/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Recording_In_ProgressInputs */



/**
* | output |
* | --- |
* | "RECORDING IN PROGRESS" |
*
* @param {Audio_Recorder_Recording_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_recording_in_progress = /** @type {((inputs?: Audio_Recorder_Recording_In_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Recording_In_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ENREGISTREMENT EN COURS")
	if (locale === "de") return /** @type {LocalizedString} */ ("AUFNAHME IN BEARBEITUNG")
	if (locale === "it") return /** @type {LocalizedString} */ ("REGISTRAZIONE IN CORSO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ЗАПИСЬ В ПРОЦЕССЕ")
	if (locale === "es") return /** @type {LocalizedString} */ ("GRABACIÓN EN CURSO")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("录制进行中")
	if (locale === "ja") return /** @type {LocalizedString} */ ("録音中")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्डिंग जारी है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("GRAVAÇÃO EM ANDAMENTO")
	return /** @type {LocalizedString} */ ("RECORDING IN PROGRESS")
});